// @ts-nocheck TODO migrate RedirectToTracking
import type { ComponentType } from 'react';
import { useSelector } from 'react-redux';

import { RedirectToTracking } from 'components/RedirectToTracking/RedirectToTracking';
import { SpinnerOverlay } from 'components/SpinnerOverlay/SpinnerOverlay';
import { hasOrder } from 'selectors/entities/order/order';
import { hasPayment } from 'selectors/entities/payment/payment';
import { isPaymentProcess } from 'selectors/ui/ui';
import { getDisplayName } from 'utils/getDisplayName/getDisplayName';
import { useTranslations } from 'utils/translations/useTranslations';

const FIVE_SECONDS_IN_MS = 5000;

const WithPaymentCompletedRedirectionHOC = <P extends Record<string, unknown>>(
  WrappedComponent: ComponentType<P>,
) => {
  const WithPaymentCompletedRedirection = (props: P) => {
    const i18n = useTranslations();

    const isInPaymentProcess = useSelector(isPaymentProcess);
    const orderExists = useSelector(hasOrder);
    const paymentExists = useSelector(hasPayment);
    const isPaymentCompleted = paymentExists && orderExists;
    const shouldRedirectToTracking = isPaymentCompleted && isInPaymentProcess;

    if (!shouldRedirectToTracking) {
      return <WrappedComponent {...props} />;
    }

    return (
      <SpinnerOverlay
        message={i18n.t(
          'paymentInformation.paymentAlreadyCompletedRedirection.message',
        )}
        className="SpinnerOverlay-transparent"
      >
        <RedirectToTracking delay={FIVE_SECONDS_IN_MS} />
      </SpinnerOverlay>
    );
  };

  WithPaymentCompletedRedirection.displayName = `WithPaymentCompletedRedirection(${getDisplayName(
    WrappedComponent,
  )})`;

  return WithPaymentCompletedRedirection;
};

export {
  WithPaymentCompletedRedirectionHOC as WithPaymentCompletedRedirection,
};
